import { createClient } from '@supabase/supabase-js'

const supabaseUrl = (import.meta as any).env?.VITE_SUPABASE_URL
const supabaseAnonKey = (import.meta as any).env?.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables. Please check your .env file.')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

// Database types
export interface Database {
  public: {
    Tables: {
      tours: {
        Row: {
          id: string
          title_en: string
          title_ar: string
          title_ur: string
          title_fa: string
          departure_date: string
          return_date: string
          duration: string
          price: string
          image: string
          route: any // JSON field
          highlights_en: string[]
          highlights_ar: string[]
          highlights_ur: string[]
          highlights_fa: string[]
          description_en: string
          description_ar: string
          description_ur: string
          description_fa: string
          images: string[]
          memories: string[]
          deleted_at: string | null
          created_at: string
          updated_at: string
        }
        Insert: {
          id?: string
          title_en: string
          title_ar: string
          title_ur: string
          title_fa: string
          departure_date: string
          return_date: string
          duration: string
          price: string
          image: string
          route: any
          highlights_en: string[]
          highlights_ar: string[]
          highlights_ur: string[]
          highlights_fa: string[]
          description_en: string
          description_ar: string
          description_ur: string
          description_fa: string
          images?: string[]
          memories?: string[]
          deleted_at?: string | null
          created_at?: string
          updated_at?: string
        }
        Update: {
          id?: string
          title_en?: string
          title_ar?: string
          title_ur?: string
          title_fa?: string
          departure_date?: string
          return_date?: string
          duration?: string
          price?: string
          image?: string
          route?: any
          highlights_en?: string[]
          highlights_ar?: string[]
          highlights_ur?: string[]
          highlights_fa?: string[]
          description_en?: string
          description_ar?: string
          description_ur?: string
          description_fa?: string
          images?: string[]
          memories?: string[]
          deleted_at?: string | null
          created_at?: string
          updated_at?: string
        }
      }
    }
  }
}
